module.exports = __webpack_public_path__ + "static/media/Costco.446570b9.png";